// extracted by mini-css-extract-plugin
export default {"content":"content__z2_gt","customBox":"customBox__t1HDv","filesList":"filesList__IKLAr"};